module.exports = __webpack_public_path__ + "img/vegetable-onions-350x184.cd92d786.jpg";